import { Fragment, useContext, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import useAxios from "axios-hooks";
import BrandContext from "./BrandContext";
import "react-datepicker/dist/react-datepicker.css";

export default function Submitted(props) {
    const theme = useContext(BrandContext);
    const nav = useNavigate();
    const params = useParams();
    const [{ data: currentPR, loading: loadingPR, error: prError }, refetchPR] = useAxios({
        method: 'get',
        url: '/pr/get',
        params: {
            id: params.prId
        },
    });
    useEffect(() => {
        // Content wasn't completed, go back to content
        if (currentPR && !currentPR?.prTitle && !currentPR?.prSlug) {
            nav('../content');
            return;
        }
        const status = currentPR?.status;
        switch (status) {
            case 'paid':
                nav('../checkout');
                return;
            default:
                break;
        }
    }, [currentPR]);


    const [
        { loading: isCreatingDraft },
        executePut
    ] = useAxios(
        {
            url: '/pr/create',
            method: 'POST'
        },
        { manual: true }
    )
    function createDraft() {
        executePut({
            data: {
                customer: currentPR.customer,
                accountId: currentPR.accountId,
                brandId: currentPR.brandId
            }
        })
            .then((r) => {
                nav(`../../${r.data.id}/details`)
            })
            .catch((e) => {
                console.error(e)
            })
            .finally(() => {

            })
    }

    return (
        <Fragment>
            {currentPR &&
                <Fragment>
                    <Container fluid="md" style={{ paddingTop: "50px", paddingBottom: "50px" }}>
                        <Row className="justify-content-center">
                            <Col sm={{ span: true, order: 'first' }} xs={{ span: 12, order: 'last' }} style={{ padding: "15px" }}>
                                <p style={{ fontSize: "14px" }}><span className="sr-light">Create</span> <span className="fw-bold text-swiftrev">&gt;</span> <span className="sr-light">Promote</span> <span className="fw-bold text-swiftrev">&gt;</span> <span className="fw-bold">Submit</span></p>
                                <p className="fw-bold" style={{ fontSize: "24px", lineHeight: "26px" }}>Success! Your press release has been submitted.</p>
                                <p>Your press release, {currentPR.prTitle}, has been submitted to editors for consideration. By using this platform instead of the "email blast" method, you're putting your best foot forward.</p>
                                <p className="fw-bold">A few things to keep in mind:</p>
                                <ul>
                                    <li>Like always, editors retain full control over what they choose to cover. <span className="fw-bold">Submitting your press release does not mean automatic editorial coverage.</span></li>
                                    <li>To confirm success of the submission, we sent you an email. You may notice a brand "SwiftRev" - that's our technology partner - but it's still us.</li>
                                    <li>You chose to not include your submission in our Press Release Channel. Change your mind? <Button style={{ padding: "0", border: "none", verticalAlign: "top", textDecorationLine: "none" }} as="div" onClick={() => createDraft()} variant="link">Click here.</Button></li>
                                </ul>
                            </Col>
                            <Col sm={{ span: 'auto', order: 'last' }} xs={{ span: 12, order: 'first' }} style={{ padding: "15px", display: "grid", alignContent: "start", justifyContent: "start" }}>
                                <Image style={{ height: "50px" }} fluid src={theme?.marketing?.logo}></Image>
                            </Col>
                        </Row>
                    </Container>
                </Fragment>
            }
        </Fragment>
    );
}